module.exports = __webpack_public_path__ + "media/promo/courses/images/hala-d5a8e2981ca4f364c2b47b4779ae45b4.png";